// 🎯 الجلسة بتنتهي بعد 30 دقيقة من غير أي تفاعل من المستخدم. قبل كده الـ Header
// كان بيجدد التوكن كل 5 دقايق طول ما التاب مفتوح حتى لو محدش لمسه، فالجلسة عمرها
// ما كانت بتنتهي. آخر نشاط متخزن في localStorage عشان كل التابات تشوفه
export const IDLE_LIMIT_MS = 30 * 60 * 1000;

const KEY = 'lastActivity';
const WRITE_THROTTLE_MS = 15 * 1000;
let lastWrite = 0;

export const markActivity = (force = false) => {
  const now = Date.now();
  if (!force && now - lastWrite < WRITE_THROTTLE_MS) return;
  lastWrite = now;
  try { localStorage.setItem(KEY, String(now)); } catch (e) { /* storage مقفول */ }
};

export const isIdleExpired = () => {
  let last = 0;
  try { last = Number(localStorage.getItem(KEY)) || 0; } catch (e) { return false; }
  // جلسة مفتوحة من قبل الميزة دي (مفيش lastActivity) - نبدأ العد من دلوقتي
  if (!last) { markActivity(true); return false; }
  return Date.now() - last >= IDLE_LIMIT_MS;
};

export const clearActivity = () => {
  try { localStorage.removeItem(KEY); } catch (e) { /* storage مقفول */ }
};
